import { EVENT_TYPES } from '../../constants';

const onDeleteMarkerRemoveDone = (state, uuid) => {
  const nextState = state.filter(id => id !== uuid);
  return nextState;
};

const onDeleteMarker = (state, uuid) => {
  const nextState = state.filter(({ id }) => id !== uuid);
  return nextState;
};

const commitMarker = (state, marker) => {
  const found = state.find(obj => obj.id === marker.id);
  if (!found) return [...state, marker];
  const nextState = state.map(obj => {
    if (obj.id !== found.id) return obj;
    return { ...obj, ...marker };
  });
  return nextState;
};

export const done = (state = [], action) => {
  switch (action.type) {
    case EVENT_TYPES.TODO_IMPORT:
      return action.payload;
    case EVENT_TYPES.TODO_TOGGLE:
      return action.payload;
    case EVENT_TYPES.USER_LOGOUT:
      return [];
    case EVENT_TYPES.MARKERS_LOADED:
      return action.payload?.done || state;
    case EVENT_TYPES.MARKER_DELETE:
      return onDeleteMarkerRemoveDone(state, action.payload);
    default:
      return state;
  }
};

export const markers = (state = [], action) => {
  switch (action.type) {
    case EVENT_TYPES.MARKERS_LOADED:
      return action.payload.pois;
    case EVENT_TYPES.MARKER_DELETE:
      return onDeleteMarker(state, action.payload);
    case EVENT_TYPES.MARKER_COMMIT:
      return commitMarker(state, action.payload);
    default:
      return state;
  }
};

export const draft = (state = null, action) => {
  switch (action.type) {
    case EVENT_TYPES.DRAFT_CREATE:
      return action.payload;
    case EVENT_TYPES.DRAFT_CANCEL:
    case EVENT_TYPES.MARKER_COMMIT:
    case EVENT_TYPES.EDITMODE_TOGGLE:
      return null;
    default:
      return state;
  }
};
